// extracted by mini-css-extract-plugin
export default {"wrapper":"content__wrapper"};